import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, createVNode as _createVNode, resolveDirective as _resolveDirective, withDirectives as _withDirectives, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "text-h5 q-mb-md" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_q_card_section = _resolveComponent("q-card-section")!
  const _component_q_btn = _resolveComponent("q-btn")!
  const _component_q_card_actions = _resolveComponent("q-card-actions")!
  const _component_q_card = _resolveComponent("q-card")!
  const _component_q_dialog = _resolveComponent("q-dialog")!
  const _directive_close_popup = _resolveDirective("close-popup")!

  return (_openBlock(), _createBlock(_component_q_dialog, {
    ref: "dialogRef",
    onCancel: _ctx.onDialogCancel,
    onHide: _ctx.onDialogHide
  }, {
    default: _withCtx(() => [
      _createVNode(_component_q_card, {
        class: "bg-white text-dark",
        style: {"width":"420px"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_q_card_section, null, {
            default: _withCtx(() => [
              _createElementVNode("div", _hoisted_1, "Delete " + _toDisplayString(_ctx.entityType), 1),
              _createElementVNode("span", null, "Are you sure you want to remove " + _toDisplayString(_ctx.entityType) + " " + _toDisplayString(_ctx.identifier) + "?", 1)
            ]),
            _: 1
          }),
          _createVNode(_component_q_card_actions, {
            align: "right",
            class: "bg-white text-teal"
          }, {
            default: _withCtx(() => [
              _withDirectives(_createVNode(_component_q_btn, {
                flat: "",
                label: "No",
                class: "text-orange-7"
              }, null, 512), [
                [_directive_close_popup]
              ]),
              _withDirectives(_createVNode(_component_q_btn, {
                flat: "",
                label: "Yes, delete!",
                onClick: _ctx.deleteEntity,
                class: "text-orange-7"
              }, null, 8, ["onClick"]), [
                [_directive_close_popup]
              ])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }, 8, ["onCancel", "onHide"]))
}